import type { Contact } from '@/types/contacts'

/**
 * Le nom à afficher pour un contact, partout (historique, textos, carnet) :
 *   - prénom ou nom : « Marie Tremblay (Tremblay inc.) » si l'entreprise est connue ;
 *   - sinon l'entreprise seule : « Tremblay inc. » ;
 *   - sinon `repli` (le numéro).
 *
 * On ne lit pas `full_name` : le serveur y met le numéro quand le prénom et
 * le nom sont vides, ce qui masquait l'entreprise.
 */
export function nomContact(
  contact: Pick<Contact, 'first_name' | 'last_name' | 'company_name'> | null | undefined,
  repli: string,
): string {
  const nom = `${contact?.first_name || ''} ${contact?.last_name || ''}`.trim()
  const entreprise = contact?.company_name?.trim() || ''
  if (nom && entreprise) return `${nom} (${entreprise})`
  return nom || entreprise || repli
}
